/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { AptosAddressSummaryInfo } from './AptosAddressSummaryInfo';
import type { AptosCoinSummaryInfo } from './AptosCoinSummaryInfo';
import type { AptosMarketplaceInfo } from './AptosMarketplaceInfo';

export type AptosCoinActionInfo = {
    ACTTP: AptosCoinActionInfo.ACTTP;
    ADDRSFROMINFO: AptosAddressSummaryInfo;
    ADDRSTOINFO: AptosAddressSummaryInfo;
    MKPINFO: AptosMarketplaceInfo;
    FC: AptosCoinSummaryInfo;
    SC: AptosCoinSummaryInfo;
    FAMT: string;
    SAMT: string;
    AMT: string;
};

export namespace AptosCoinActionInfo {

    export enum ACTTP {
        TRANSFER = 'TRANSFER',
        SWAP = 'SWAP',
        DEPOSIT = 'DEPOSIT',
        STAKE = 'STAKE',
        UNSTAKE = 'UNSTAKE',
        CLAIM = 'CLAIM',
        ADD_LIQUIDITY = 'ADD_LIQUIDITY',
        REMOVE_LIQUIDITY = 'REMOVE_LIQUIDITY',
        BRIDGE_SEND = 'BRIDGE_SEND',
        BRIDGE_RECEIVE = 'BRIDGE_RECEIVE',
        ADD_DELEGATE = 'ADD_DELEGATE',
        UNLOCK_DELEGATE = 'UNLOCK_DELEGATE',
        WITHDRAW_DELEGATE = 'WITHDRAW_DELEGATE',
        ADD_STAKE = 'ADD_STAKE',
        WITHDRAW_STAKE = 'WITHDRAW_STAKE',
        UNLOCK_STAKE = 'UNLOCK_STAKE',
    }


}

